import { render, staticRenderFns } from "./AdWizard.vue?vue&type=template&id=713b35a8&scoped=true&"
import script from "./AdWizard.vue?vue&type=script&lang=js&"
export * from "./AdWizard.vue?vue&type=script&lang=js&"
import style0 from "./AdWizard.vue?vue&type=style&index=0&id=713b35a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b35a8",
  null
  
)

export default component.exports